import { Box, Text } from "@chakra-ui/react";

export function MetricCard({ value, label }: { value: number; label: string }) {
  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="10px"
      px="20px"
      py="14px"
      minW="90px"
      textAlign="center"
      boxShadow="0 1px 3px rgba(0,0,0,0.06)"
    >
      <Text
        fontSize="28px"
        fontWeight="700"
        color="#1E293B"
        lineHeight="1"
        mb="4px"
      >
        {value}
      </Text>
      <Text
        fontSize="10px"
        fontWeight="700"
        color="gray.400"
        textTransform="uppercase"
        letterSpacing="1px"
      >
        {label}
      </Text>
    </Box>
  );
}
